import { zodResolver } from '@hookform/resolvers/zod';
import type { FieldValues, Resolver, UseFormProps } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import type { z, ZodType } from 'zod';

interface UseZodFormProps<
  Z extends ZodType<FieldValues, FieldValues>,
> extends Omit<UseFormProps<z.output<Z>>, 'resolver'> {
  schema: Z;
}

export const useZodForm = <Z extends ZodType<FieldValues, FieldValues>>({
  schema,
  ...formProps
}: UseZodFormProps<Z>) =>
  useForm<z.output<Z>>({
    ...formProps,
    resolver: zodResolver(schema) as unknown as Resolver<z.output<Z>>,
  });
